import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';
import DOMPurify from 'dompurify';

window.DOMPurify = DOMPurify;

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root DOM container #root was not found in index.html');
}
const root = ReactDOM.createRoot(rootElement);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
